<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" /> 

    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Nome Participante</label>
                <div class="field-label">{{ objView.nmpessoa }}</div>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Data Registro</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtregistro) }}</div>
            </div>
            
            <div class="form-item-char40">
                <label class="label-caption">Programa</label>
                <div class="field-label">{{ objView.nmprograma }}</div>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Nome Fornecedor</label>
                <div class="field-label">{{ objView.nmfornecedor }}</div>
            </div>
            
            <div class="form-item-char40">
                <label class="label-caption">Situação Documento</label>
                <div class="field-label">{{ objView.nmstatus }}</div>
            </div>
        </div>

        
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Modelo</label>
                <div class="field-label field-label-center">{{ `${objView.dfmodelo} / ${objView.tpnota}` }}</div>
            </div>

            <div class="form-item-char05">
                <label class="label-caption">Série</label>
                <div class="field-label field-label-end">{{ objView.dfserie }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Número</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.dfnumero) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Chave</label>
                <div class="field-label">{{ objView.dfchave }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Valor Digitado</label>
                <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objView.dfvalor) }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Valor Autorizado</label>
                <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objView.vlautorizado) }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Valor Utilizado</label>
                <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objView.vlvinculado) }}</div>
            </div>
        </div>

        
        <div class="row-end">
            <button v-if="showBtAnexo" @click="abrirAnexo">Visualizar/Download</button>
            <button @click="closeForm">Retornar</button>
        </div>
    </div>


    <div v-if="lsDados.length>0" class="table-wrapper">
        <table>
            <thead>
                <tr>
                    <th>Nro Cupom</th>
                    <th>Emissão</th>
                    <th>Participante</th>
                    <th>Situação</th>
                    <th>Utilizado</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-char15 right">{{ Funcoes.formatInteger(obj.nrocupom) }}</td>
                    <td class="col-width-char20 center">{{ Funcoes.formatDateTimeFromJson(obj.dhcupom) }}</td>
                    <td>{{ obj.nmpessoa }}</td>
                    <td class="col-width-char20">{{ obj.nmstatus_cupom }}</td>
                    <td class="col-width-char20 right">{{ Funcoes.formatDecimal(obj.vlutilizado) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);
const props = defineProps({idView: {type: Number, default: 0}});

const isLoading = ref(false);
const lsDados = ref([]);
const msgAlerta = ref(false);
const objView = ref({});
const showBtAnexo = ref(false);


function abrirAnexo() {
    if (objView.value.url_anexo) {
        window.open(objView.value.url_anexo, '_blank');
    }
}


function closeForm() {emit('close');}


async function lerDados() {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/notas', {idmunicipio: globalStore.idmunicipio, id: props.idView});
        Object.assign(objView.value, req[0]);
        showBtAnexo.value = objView.value.url_anexo;

        const reqNotas = await Api.genericPost('/listas/cupons_notas', {
            idmunicipio: globalStore.idmunicipio,
            intparam2: props.idView});
        lsDados.value = reqNotas;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}

onMounted(lerDados);
</script>